import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useHighFrequencyRefreshQuery } from '../../../queryDefaults/baseQueries/useHighFrequencyRefreshQuery';
import { TasksApi } from '../../../apis/TasksApi/TasksApi.ts';
import { ITask, Task } from '../Tasks.ts';
import { useIdFromRoute } from '../../../hooks/useIdFromRoute.tsx';
import { useTranslation } from 'react-i18next';

export function useGetTaskById() {
    const id = useIdFromRoute();
    const { i18n } = useTranslation();

    return useHighFrequencyRefreshQuery({
        queryKey: [QueryKeys.tasks, id, i18n.language],
        queryFn: async () => {
            const result: ITask = await TasksApi.getTaskById(id!);
            return new Task(result);
        },
        enabled: !!id,
    });
}
